import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96bfdec0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DrainageStatistics" }
const _hoisted_2 = { class: "statistics" }
const _hoisted_3 = { class: "itemModal" }
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = { style: {"height":"50px","display":"inline-flex","margin":"0 auto"} }
const _hoisted_6 = { style: {"height":"50px","line-height":"50px","text-align":"center","margin-left":"14px"} }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {getListData, getPageListData, postData} from "@/service/main/system";
import {useStore} from "@/store";
import {initEmptyParam} from "@/hooks/useInitParam";
import {ref, watch} from "vue";
import dayjs from 'dayjs'
import {customerTableConfig} from "./config/customer.config";
import LfTable from "@/components/LfTable.vue";
import {ElLoading} from "element-plus";
import {queryDrainageStatistics} from "@/service/main/live/statitiscal";


export default /*#__PURE__*/_defineComponent({
  __name: 'DrainageStatistics',
  setup(__props) {

initEmptyParam()
const store = useStore()
const permissions = store.state.login.permissions

const getChannelList = async () => {
  let channelData = await getListData('/main/customerChannel/queryAllChannel', {})
  const channelItem = searchFormConfig.formItems.find(item => item.field === 'sourceLabel')
  channelItem!.options = channelData.map((item: any) => {
    return {title: item, value: item}
  })
}
getChannelList()

const getThirdPartyList = async () => {
  let thirdPartyData = await getListData('/main/customerChannel/queryThirdParty', {})
  const thirdPartyItem = searchFormConfig.formItems.find((item) => item.field === 'thirdParty')
  thirdPartyItem!.options = thirdPartyData.map((item: any) => {
    return {title: item, value: item}
  })
}
getThirdPartyList()

const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})
  const roleItem = searchFormConfig.formItems.find((item) => item.field === 'corpName')
  roleItem!.options = roleData.map((item: any) => {
    return {title: item.name, value: item.name}
  })
}
getCompanyList()

const queryParam = {
  timeSlot: [
    dayjs().startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ],
  cfddFlag: false,
  pageNo: 1,
  pageSize: 10
}
store.commit('system/changeQueyryInfo', queryParam)

const resetCb = () => {
  getStatistics(queryParam)
  return queryParam
}

const searchCb = () => {}

// 自定义重复量
const repeatDialogVisible = ref(false)
let repeatInfo = ref()
let repeatNum = ref(0)
const handleUpdateRepeatNum = (item: any) => {
  console.log(item)
  repeatDialogVisible.value = true
  repeatInfo.value = item
  repeatNum.value = item.customizeRepeatNum
}

const repeatTipDialog = async (item: any) => {
  if (item) {
    try {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: '修改数据中...',
        background: 'rgba(0, 0, 0, 0.5)'
      });
      await postData('/main/drainageStatistics/updateRepeatNum', {
        userId: repeatInfo.value.userId,
        corpName: repeatInfo.value.corpName,
        unionId: repeatInfo.value.unionId,
        repeatNum: repeatNum.value,
        cfddFlag: queryParam.cfddFlag,
        startTime: store.state.system.queryInfo.timeSlot[0],
        endTime: store.state.system.queryInfo.timeSlot[1]
      }).then(() => {
        loadingInstance.close()
        repeatDialogVisible.value = false
        getListPageData(queryItemInfo)
        initData()
      })
    } catch (e) {
      repeatDialogVisible.value = false
    }
  } else {
    repeatDialogVisible.value = false
  }
}

const initData = () => {
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const listDialogVisible = ref(false)
const listDialogTitle = ref('')
const listTableTitle = ref('');
const dataList = ref<any[]>([])
const dataCount = ref<number>(0)
const pageInfo = ref({pageNo: 1, pageSize: 10})
let queryItemInfo = {
  thirdParty: '',
  sourceLabel: '',
  channel: '',
  third: '',
  userId: -1,
  corpName: '',
  timeSlot: [],
  pageNo: 1,
  pageSize: 10
}

const handleItemClick = (item: any) => {
  listDialogVisible.value = true;
  listDialogTitle.value = '详情记录'
  listTableTitle.value = '客户列表'
  getListPageData(item);
}

const getListPageData = async (item: any) => {
  queryItemInfo = {
    pageNo: pageInfo.value.pageNo,
    pageSize: pageInfo.value.pageSize,
    timeSlot: store.state.system.queryInfo.timeSlot,
    userId: item.userId,
    corpName: item.corpName,
    sourceLabel: item.channel,
    channel: item.channel,
    third: item.thirdParty,
    thirdParty: item.thirdParty
  }
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '查询数据中...',
    background: 'rgba(0, 0, 0, 0.5)'
  });
  await getPageListData(
    '/main/drainageStatistics/queryDetailsByUserId',
    queryItemInfo
  ).then((res) => {
    loadingInstance.close()
    dataList.value = res.list
    dataCount.value = Number(res.total)
  })
}

const dialogClose = () => {
  dataList.value = [];
  pageInfo.value.pageNo = 1;
  pageInfo.value.pageSize = 10;
  dataCount.value = 0;
}
watch(pageInfo, () => getListPageData(queryItemInfo))

const statistics = ref({totalCount: '--', deletedCount: '--', repeatCount: '--'})
const getStatistics = async (item: any) => {
  statistics.value = await queryDrainageStatistics({
    userId: item.userId,
    corpName: item.corpName,
    timeSlot: item.timeSlot,
    sourceLabel: item.sourceLabel,
    thirdParty: item.thirdParty
  })
}
getStatistics(queryParam)

const afterSearchCb = () => {
  statistics.value = {totalCount: '--', deletedCount: '--', repeatCount: '--'}
  getStatistics(store.state.system.queryInfo)
}

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick] = usePageSearch(resetCb, searchCb, afterSearchCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createTextVNode("添加人数: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.totalCount), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("删微人数: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.deletedCount), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("重复数量: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.repeatCount), 1)
      ])
    ]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "drainageStatistics",
      onViewClick: handleItemClick,
      downFilename: "引流统计.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick),
      onSortChange: handleSortChange
    }, null, 8, ["contentTableConfig", "onDownBtnClick"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_dialog, {
        modelValue: repeatDialogVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((repeatDialogVisible).value = $event)),
        title: "设置重复量",
        width: "30%",
        "destroy-on-close": "",
        center: ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (repeatTipDialog(false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (repeatTipDialog(true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("确认")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "重复量：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(repeatNum),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(repeatNum) ? (repeatNum).value = $event : repeatNum = $event)),
                    type: "number"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        title: listDialogTitle.value,
        modelValue: listDialogVisible.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((listDialogVisible).value = $event)),
        width: "50%",
        center: "",
        "destroy-on-close": "",
        onClosed: dialogClose
      }, {
        default: _withCtx(() => [
          _createVNode(LfTable, _mergeProps({
            listData: dataList.value,
            listCount: dataCount.value,
            title: listTableTitle.value
          }, _unref(customerTableConfig), {
            page: pageInfo.value,
            "onUpdate:page": _cache[4] || (_cache[4] = ($event: any) => ((pageInfo).value = $event))
          }), {
            consumer: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_avatar, {
                  shape: "square",
                  size: 50,
                  src: scope.row.avatar
                }, null, 8, ["src"]),
                _createElementVNode("span", _hoisted_6, _toDisplayString(scope.row.uname), 1)
              ])
            ]),
            customizeRepeatNum: _withCtx((scope) => [
              (_unref(permissions).includes('sys:drainageStatistics:operate'))
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 0,
                    class: "text-link",
                    onClick: _withModifiers(($event: any) => (handleUpdateRepeatNum(scope.row)), ["stop","prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.customizeRepeatNum), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 16, ["listData", "listCount", "title", "page"])
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ])
  ]))
}
}

})